import { render, staticRenderFns } from "./StandartModule.vue?vue&type=template&id=f6ea5e82&"
import script from "./StandartModule.vue?vue&type=script&lang=js&"
export * from "./StandartModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports